

export const INITIAL_STATE = {
  preregistrationId: null,
  isMedical: null,
  personType: "",
  documentType: "CEDULA",
  documentNumber: "",
  officeName: "",
  commercialName: "",
  branchName: "",
  physicalFirstName: "",
  physicalMiddleName: "",
  physicalLastName: "",
  physicalLastName2: "",
  physicalCellphone: "",
  physicalPhone: "",
  physicalPhone2: "",
  physicalEmail: "",
  physicalAddress: "",
  physicalProvince: "",
  physicalMunicipality: "",
  physicalSector: "",
  physicalExequatur: "",
  specialities: [],
  specialityDraftPending: false,
  businessName: "",
  businessCellphone: "",
  businessPhone: "",
  businessEmail: "",
  businessAddress: "",
  businessProvince: "",
  businessMunicipality: "",
  businessSector: "",
  repDocumentType: "CEDULA",
  repDocumentNumber: "",
  repFirstName: "",
  repMiddleName: "",
  repLastName: "",
  repLastName2: "",
  repCellphone: "",
  repPhone: "",
  repPhone2: "",
  repEmail: "",
  documentRequirements: {},
  termsAccepted: false,
  privacyAccepted: false,
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const DUPLICATE_USER_OR_EMAIL_MESSAGE =
  "El usuario o correo ingresado ya existe en el sistema";

export const TAXPAYER_NOT_FOUND_MESSAGE =
  "Debe revisar su registro de RNC en la Dirección General de impuestos Internos, pues este número no figura en la base de datos de la institución.";

export const DUPLICATED_PROVIDER_RNC_MESSAGE =
  "Ya existe un consultorio registrado con este RNC. Verifica los datos antes de continuar.";

export const UPLOAD_SIZE_ERROR_MESSAGE =
  "El servidor rechazo la carga porque supero el tamano permitido. Reduzca o comprima los documentos y vuelva a intentar.";

export const UPLOAD_CONNECTION_ERROR_MESSAGE =
  "La conexion con el servidor se interrumpio antes de recibir respuesta. Intente nuevamente. Si persiste, revise la disponibilidad del API.";

export const RECOVERED_SUBMISSION_MESSAGE =
  "Solicitud recibida correctamente. Su registro sera revisado por administracion.";

export const RECOVERY_ATTEMPT_DELAYS_MS = [0, 1200, 2500, 4000];

export const INITIAL_IDENTITY_VALIDATION = {
  status: "idle",
  message: "",
  foundData: false,
  taxpayerFound: false,
};

export const INITIAL_REPRESENTATIVE_VALIDATION = {
  status: "idle",
  message: "",
  existingUser: null,
  lockedFields: {},
};

export const RESET_IDENTITY_VALIDATION_FIELDS = new Set([
  "isMedical",
  "personType",
  "documentNumber",
]);

export const RESET_AFTER_IDENTITY_CHANGE = {
  preregistrationId: null,
  officeName: "",
  commercialName: "",
  branchName: "",
  physicalFirstName: "",
  physicalMiddleName: "",
  physicalLastName: "",
  physicalLastName2: "",
  physicalCellphone: "",
  physicalPhone: "",
  physicalPhone2: "",
  physicalEmail: "",
  physicalAddress: "",
  physicalProvince: "",
  physicalMunicipality: "",
  physicalSector: "",
  physicalExequatur: "",
  specialities: [],
  specialityDraftPending: false,
  businessName: "",
  businessCellphone: "",
  businessPhone: "",
  businessEmail: "",
  businessAddress: "",
  businessProvince: "",
  businessMunicipality: "",
  businessSector: "",
  repDocumentType: "CEDULA",
  repDocumentNumber: "",
  repFirstName: "",
  repMiddleName: "",
  repLastName: "",
  repLastName2: "",
  repCellphone: "",
  repPhone: "",
  repPhone2: "",
  repEmail: "",
  documentRequirements: {},
  termsAccepted: false,
  privacyAccepted: false,
};
